import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[72px] w-full rounded-lg border border-input bg-[color:var(--surface-2)] px-3 py-2 text-base text-foreground shadow-[0_1px_2px_rgba(12, 15, 14,0.3)] placeholder:text-[color:var(--text-3)] transition-colors hover:border-[color:var(--accent-blue)]/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:bg-[color:var(--surface-1)] disabled:opacity-60 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
